<div class="trip-container" [ngClass]="{ 'trip-container--wl-mode': wlMode }">
  <div
    [@addAnimate]
    (@addAnimate.done)="animationDone()"
    *ngIf="showAddAnimateIcon"
    class="added-animate-icon"
  >
    <ng-container [ngSwitch]="wlMode">
      <ng-container *ngSwitchCase="true">
        <ng-container *ngTemplateOutlet="tmpWlSvg"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="tmpNoWlSvg"></ng-container>
      </ng-container>
    </ng-container>
  </div>

  <a
    class="bm-header-btn-wrapper"
    [ngClass]="{ 'bm-header-btn-wrapper--wl-mode': wlMode }"
    [routerLink]="['/your-plans']"
    (click)="showTripPlanClick()"
  >
    <button
      #tripButton
      class="bm-button bm-open-button"
      [ngClass]="{
        'bm-open-button--text': !boxBtnMode,
        'bm-open-button--box': boxBtnMode
      }"
      *ngIf="checkCount()"
    >
      <i>
        <ng-container [ngSwitch]="wlMode">
          <ng-container *ngSwitchCase="true">
            <ng-container *ngTemplateOutlet="tmpWlSvg"></ng-container>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="tmpNoWlSvg"></ng-container>
          </ng-container>
        </ng-container>
      </i>
      <span [translate]="'trip-plans-title'"></span>
      <span *ngIf="!wlMode && count > 0">({{ count }})</span>
      <span *ngIf="wlMode && count > 0" class="bm-alert-count">{{
        count
      }}</span>
    </button>
  </a>
</div>

<ng-template #tmpWlSvg>
  <svg
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4053 18.2057L15.4052 18.2056L9.21012 13.372C9.21009 13.3719 9.21005 13.3719 9.21002 13.3719C8.53 12.8411 7.46503 12.846 6.79039 13.3717L6.79014 13.3719L0.594952 18.2056L0.594848 18.2057C0.561111 18.232 0.532009 18.2513 0.507802 18.2653C0.503372 18.2354 0.500165 18.1971 0.500165 18.1495L0.5 1.55422C0.5 1.55422 0.5 1.55422 0.5 1.55422C0.500003 1.19163 0.791982 0.900391 1.15067 0.900391H14.8493C15.2098 0.900391 15.5 1.18455 15.5 1.55422V18.1495C15.5 18.1973 15.4966 18.2352 15.4919 18.2645C15.4681 18.251 15.4391 18.2321 15.4053 18.2057Z"
      class="bm-open-button-svg-path bm-open-button-svg-path--stroke"
    />
  </svg>
</ng-template>

<ng-template #tmpNoWlSvg>
  <svg
    width="15"
    height="21"
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.637227 20.9969C0.274673 20.9624 -0.00181905 20.652 9.07639e-06 20.2811V1.67021C9.07639e-06 0.757748 0.744337 2.45751e-08 1.64063 2.45751e-08H13.3594C14.2557 2.45751e-08 15 0.757748 15 1.67021V20.2811C15.0009 20.5486 14.8553 20.7937 14.6228 20.9177C14.3903 21.0416 14.1092 21.023 13.894 20.8701L7.50005 16.3816L1.10607 20.8701C0.969657 20.968 0.803024 21.0127 0.637321 20.9969L0.637227 20.9969ZM1.40626 18.9166L7.09711 14.92C7.3388 14.7476 7.66107 14.7476 7.90278 14.92L13.5936 18.9166V1.67025C13.5936 1.52579 13.5012 1.43165 13.3593 1.43165H1.64052C1.49861 1.43165 1.40614 1.52579 1.40614 1.67025L1.40626 18.9166Z"
      fill="#333"
    />
  </svg>
</ng-template>
